import { ToastProvider } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import AdminStudioRoutes from './app/AdminStudioRoutes.jsx';
import { PersonaDemoBar } from './domains/integrations';

/**
 * Root component of the Admin Studio application.
 * Mounted by the Core Shell under <Route path="admin-studio/*">.
 * Also usable standalone via main.jsx.
 *
 * Admin Studio hosts several domains (the prototype shows Catalog · Requests ·
 * Distribution · Workspaces · Users · Widgets); `integrations` is the first.
 */
const AdminStudioApp = () => {
  const { ready, t } = useTranslation('admin-studio');

  if (!ready) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-content-muted">
        {t('common.loading')}
      </div>
    );
  }

  return (
    <ToastProvider
      config={{
        position: 'top-right',
        defaultDuration: 4000,
        defaultMaxWidth: '480px',
        defaultMinWidth: '320px',
      }}
    >
      <div className="flex h-full flex-1 flex-col overflow-hidden">
        {/* Demo persona toggle (CT-4203) — MOCK RBAC affordance; removed with CT-3900. */}
        <PersonaDemoBar />
        <AdminStudioRoutes />
      </div>
    </ToastProvider>
  );
};

export default AdminStudioApp;
